import * as ambassadorWixMembersV1Member from './members-v1-member-members.http.js';
import * as ambassadorWixMembersV1MemberTypes from './members-v1-member-members.types.js';
import * as ambassadorWixMembersV1MemberUniversalTypes from './members-v1-member-members.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function updateCurrentMemberSlug(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.UpdateMySlugRequest,
  ambassadorWixMembersV1MemberTypes.UpdateMySlugRequest,
  ambassadorWixMembersV1MemberUniversalTypes.UpdateMySlugResponse,
  ambassadorWixMembersV1MemberTypes.UpdateMySlugResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixMembersV1Member.updateMySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/my/slug',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMemberSlug(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.UpdateMemberSlugRequest,
  ambassadorWixMembersV1MemberTypes.UpdateMemberSlugRequest,
  ambassadorWixMembersV1MemberUniversalTypes.UpdateMemberSlugResponse,
  ambassadorWixMembersV1MemberTypes.UpdateMemberSlugResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.updateMemberSlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/{id}/slug',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function joinCommunity(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.JoinCommunityRequest,
  ambassadorWixMembersV1MemberTypes.JoinCommunityRequest,
  ambassadorWixMembersV1MemberUniversalTypes.JoinCommunityResponse,
  ambassadorWixMembersV1MemberTypes.JoinCommunityResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixMembersV1Member.joinCommunity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/join-community',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function leaveCommunity(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.LeaveCommunityRequest,
  ambassadorWixMembersV1MemberTypes.LeaveCommunityRequest,
  ambassadorWixMembersV1MemberUniversalTypes.LeaveCommunityResponse,
  ambassadorWixMembersV1MemberTypes.LeaveCommunityResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.leaveCommunity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/leave-community',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCurrentMember(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.GetMyMemberRequest,
  ambassadorWixMembersV1MemberTypes.GetMyMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.GetMyMemberResponse,
  ambassadorWixMembersV1MemberTypes.GetMyMemberResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixMembersV1Member.getMyMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/members/my',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMember(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.GetMemberRequest,
  ambassadorWixMembersV1MemberTypes.GetMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.GetMemberResponse,
  ambassadorWixMembersV1MemberTypes.GetMemberResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixMembersV1Member.getMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/members/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMembers(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.ListMembersRequest,
  ambassadorWixMembersV1MemberTypes.ListMembersRequest,
  ambassadorWixMembersV1MemberUniversalTypes.ListMembersResponse,
  ambassadorWixMembersV1MemberTypes.ListMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixMembersV1Member.listMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/members',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryMembers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.QueryMembersRequest,
  ambassadorWixMembersV1MemberTypes.QueryMembersRequest,
  ambassadorWixMembersV1MemberUniversalTypes.QueryMembersResponse,
  ambassadorWixMembersV1MemberTypes.QueryMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixMembersV1Member.queryMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function muteMember(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.MuteMemberRequest,
  ambassadorWixMembersV1MemberTypes.MuteMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.MuteMemberResponse,
  ambassadorWixMembersV1MemberTypes.MuteMemberResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixMembersV1Member.muteMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/{id}/mute',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unmuteMember(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.UnmuteMemberRequest,
  ambassadorWixMembersV1MemberTypes.UnmuteMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.UnmuteMemberResponse,
  ambassadorWixMembersV1MemberTypes.UnmuteMemberResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixMembersV1Member.unmuteMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/{id}/unmute',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function approveMember(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.ApproveMemberRequest,
  ambassadorWixMembersV1MemberTypes.ApproveMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.ApproveMemberResponse,
  ambassadorWixMembersV1MemberTypes.ApproveMemberResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixMembersV1Member.approveMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/{id}/approve',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function blockMember(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.BlockMemberRequest,
  ambassadorWixMembersV1MemberTypes.BlockMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.BlockMemberResponse,
  ambassadorWixMembersV1MemberTypes.BlockMemberResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixMembersV1Member.blockMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/{id}/block',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function disconnectMember(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.DisconnectMemberRequest,
  ambassadorWixMembersV1MemberTypes.DisconnectMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.DisconnectMemberResponse,
  ambassadorWixMembersV1MemberTypes.DisconnectMemberResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.disconnectMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/{id}/disconnect',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMember(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberRequest,
  ambassadorWixMembersV1MemberTypes.DeleteMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberResponse,
  ambassadorWixMembersV1MemberTypes.DeleteMemberResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixMembersV1Member.deleteMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/members/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMyMember(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMyMemberRequest,
  ambassadorWixMembersV1MemberTypes.DeleteMyMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMyMemberResponse,
  ambassadorWixMembersV1MemberTypes.DeleteMyMemberResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.deleteMyMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/members/my',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteMembers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.BulkDeleteMembersRequest,
  ambassadorWixMembersV1MemberTypes.BulkDeleteMembersRequest,
  ambassadorWixMembersV1MemberUniversalTypes.BulkDeleteMembersResponse,
  ambassadorWixMembersV1MemberTypes.BulkDeleteMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.bulkDeleteMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/bulk/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteMembersByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.BulkDeleteMembersByFilterRequest,
  ambassadorWixMembersV1MemberTypes.BulkDeleteMembersByFilterRequest,
  ambassadorWixMembersV1MemberUniversalTypes.BulkDeleteMembersByFilterResponse,
  ambassadorWixMembersV1MemberTypes.BulkDeleteMembersByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.bulkDeleteMembersByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/bulk/delete-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkApproveMembers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.BulkApproveMembersRequest,
  ambassadorWixMembersV1MemberTypes.BulkApproveMembersRequest,
  ambassadorWixMembersV1MemberUniversalTypes.BulkApproveMembersResponse,
  ambassadorWixMembersV1MemberTypes.BulkApproveMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.bulkApproveMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/bulk/approve-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkBlockMembers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.BulkBlockMembersRequest,
  ambassadorWixMembersV1MemberTypes.BulkBlockMembersRequest,
  ambassadorWixMembersV1MemberUniversalTypes.BulkBlockMembersResponse,
  ambassadorWixMembersV1MemberTypes.BulkBlockMembersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.bulkBlockMembers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members/bulk/block-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createMember(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1MemberUniversalTypes.CreateMemberRequest,
  ambassadorWixMembersV1MemberTypes.CreateMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.CreateMemberResponse,
  ambassadorWixMembersV1MemberTypes.CreateMemberResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixMembersV1Member.createMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/members',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMember(): __PublicMethodMetaInfo<
  'PATCH',
  { memberId: string },
  ambassadorWixMembersV1MemberUniversalTypes.UpdateMemberRequest,
  ambassadorWixMembersV1MemberTypes.UpdateMemberRequest,
  ambassadorWixMembersV1MemberUniversalTypes.UpdateMemberResponse,
  ambassadorWixMembersV1MemberTypes.UpdateMemberResponse
> {
  const payload = { member: { id: ':memberId' } } as any;

  const getRequestOptions = ambassadorWixMembersV1Member.updateMember(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/members/{member.id}',
    pathParams: { memberId: 'memberId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMemberPhones(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberPhonesRequest,
  ambassadorWixMembersV1MemberTypes.DeleteMemberPhonesRequest,
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberPhonesResponse,
  ambassadorWixMembersV1MemberTypes.DeleteMemberPhonesResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.deleteMemberPhones(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/members/{id}/phones',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMemberEmails(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberEmailsRequest,
  ambassadorWixMembersV1MemberTypes.DeleteMemberEmailsRequest,
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberEmailsResponse,
  ambassadorWixMembersV1MemberTypes.DeleteMemberEmailsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.deleteMemberEmails(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/members/{id}/emails',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMemberAddresses(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberAddressesRequest,
  ambassadorWixMembersV1MemberTypes.DeleteMemberAddressesRequest,
  ambassadorWixMembersV1MemberUniversalTypes.DeleteMemberAddressesResponse,
  ambassadorWixMembersV1MemberTypes.DeleteMemberAddressesResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1Member.deleteMemberAddresses(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/members/{id}/addresses',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Member as MemberOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Contact as ContactOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  CustomField as CustomFieldOriginal,
  Profile as ProfileOriginal,
  Image as ImageOriginal,
  PrivacyStatusStatus as PrivacyStatusStatusOriginal,
  PrivacyStatusStatusWithLiterals as PrivacyStatusStatusWithLiteralsOriginal,
  ActivityStatusStatus as ActivityStatusStatusOriginal,
  ActivityStatusStatusWithLiterals as ActivityStatusStatusWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  UpdateMySlugRequest as UpdateMySlugRequestOriginal,
  UpdateMySlugResponse as UpdateMySlugResponseOriginal,
  SlugAlreadyExistsPayload as SlugAlreadyExistsPayloadOriginal,
  UpdateMemberSlugRequest as UpdateMemberSlugRequestOriginal,
  UpdateMemberSlugResponse as UpdateMemberSlugResponseOriginal,
  JoinCommunityRequest as JoinCommunityRequestOriginal,
  JoinCommunityResponse as JoinCommunityResponseOriginal,
  MemberJoinedCommunity as MemberJoinedCommunityOriginal,
  LeaveCommunityRequest as LeaveCommunityRequestOriginal,
  LeaveCommunityResponse as LeaveCommunityResponseOriginal,
  MemberLeftCommunity as MemberLeftCommunityOriginal,
  GetMyMemberRequest as GetMyMemberRequestOriginal,
  Set as SetOriginal,
  SetWithLiterals as SetWithLiteralsOriginal,
  GetMyMemberResponse as GetMyMemberResponseOriginal,
  GetMemberRequest as GetMemberRequestOriginal,
  GetMemberResponse as GetMemberResponseOriginal,
  MemberToMemberBlockedPayload as MemberToMemberBlockedPayloadOriginal,
  ListMembersRequest as ListMembersRequestOriginal,
  Paging as PagingOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  ListMembersResponse as ListMembersResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryMembersRequest as QueryMembersRequestOriginal,
  Query as QueryOriginal,
  Search as SearchOriginal,
  QueryMembersResponse as QueryMembersResponseOriginal,
  MuteMemberRequest as MuteMemberRequestOriginal,
  MuteMemberResponse as MuteMemberResponseOriginal,
  MemberMuted as MemberMutedOriginal,
  UnmuteMemberRequest as UnmuteMemberRequestOriginal,
  UnmuteMemberResponse as UnmuteMemberResponseOriginal,
  MemberUnmuted as MemberUnmutedOriginal,
  ApproveMemberRequest as ApproveMemberRequestOriginal,
  ApproveMemberResponse as ApproveMemberResponseOriginal,
  MemberApproved as MemberApprovedOriginal,
  BlockMemberRequest as BlockMemberRequestOriginal,
  BlockMemberResponse as BlockMemberResponseOriginal,
  MemberBlocked as MemberBlockedOriginal,
  MemberSelfBlockForbiddenPayload as MemberSelfBlockForbiddenPayloadOriginal,
  OwnerMemberBlockForbiddenPayload as OwnerMemberBlockForbiddenPayloadOriginal,
  ActiveSubscriptionMemberBlockForbiddenPayload as ActiveSubscriptionMemberBlockForbiddenPayloadOriginal,
  DisconnectMemberRequest as DisconnectMemberRequestOriginal,
  DisconnectMemberResponse as DisconnectMemberResponseOriginal,
  DeleteMemberRequest as DeleteMemberRequestOriginal,
  DeleteMemberResponse as DeleteMemberResponseOriginal,
  ContentReassignmentRequested as ContentReassignmentRequestedOriginal,
  ContentDeletionRequested as ContentDeletionRequestedOriginal,
  OwnerOrContributorDeleteForbiddenPayload as OwnerOrContributorDeleteForbiddenPayloadOriginal,
  ActiveSubscriptionMemberDeleteForbiddenPayload as ActiveSubscriptionMemberDeleteForbiddenPayloadOriginal,
  DeleteMyMemberRequest as DeleteMyMemberRequestOriginal,
  DeleteMyMemberResponse as DeleteMyMemberResponseOriginal,
  BulkDeleteMembersRequest as BulkDeleteMembersRequestOriginal,
  BulkDeleteMembersResponse as BulkDeleteMembersResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkMemberResult as BulkMemberResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkDeleteMembersByFilterRequest as BulkDeleteMembersByFilterRequestOriginal,
  BulkDeleteMembersByFilterResponse as BulkDeleteMembersByFilterResponseOriginal,
  BulkApproveMembersRequest as BulkApproveMembersRequestOriginal,
  BulkApproveMembersResponse as BulkApproveMembersResponseOriginal,
  BulkBlockMembersRequest as BulkBlockMembersRequestOriginal,
  BulkBlockMembersResponse as BulkBlockMembersResponseOriginal,
  CreateMemberRequest as CreateMemberRequestOriginal,
  CreateMemberResponse as CreateMemberResponseOriginal,
  UpdateMemberRequest as UpdateMemberRequestOriginal,
  UpdateMemberResponse as UpdateMemberResponseOriginal,
  InvalidCustomFieldUrlPayload as InvalidCustomFieldUrlPayloadOriginal,
  DeleteMemberPhonesRequest as DeleteMemberPhonesRequestOriginal,
  DeleteMemberPhonesResponse as DeleteMemberPhonesResponseOriginal,
  DeleteMemberEmailsRequest as DeleteMemberEmailsRequestOriginal,
  DeleteMemberEmailsResponse as DeleteMemberEmailsResponseOriginal,
  DeleteMemberAddressesRequest as DeleteMemberAddressesRequestOriginal,
  DeleteMemberAddressesResponse as DeleteMemberAddressesResponseOriginal,
  Empty as EmptyOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  MemberOwnershipTransferred as MemberOwnershipTransferredOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MemberIdChanged as MemberIdChangedOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateMySlugApplicationErrors as UpdateMySlugApplicationErrorsOriginal,
  UpdateMemberSlugApplicationErrors as UpdateMemberSlugApplicationErrorsOriginal,
  JoinCommunityApplicationErrors as JoinCommunityApplicationErrorsOriginal,
  GetMyMemberApplicationErrors as GetMyMemberApplicationErrorsOriginal,
  GetMemberApplicationErrors as GetMemberApplicationErrorsOriginal,
  BlockMemberApplicationErrors as BlockMemberApplicationErrorsOriginal,
  DeleteMemberValidationErrors as DeleteMemberValidationErrorsOriginal,
  DeleteMyMemberValidationErrors as DeleteMyMemberValidationErrorsOriginal,
  UpdateMemberValidationErrors as UpdateMemberValidationErrorsOriginal,
} from './members-v1-member-members.types.js';
